export class EditUserPostnummer {
    constructor(userId: string, postnummer: string) {
        this.userId = userId;
        this.postnummer = postnummer;
    }

    userId: string;
    postnummer?: string;
}
